import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/state/authStore';

export function LogoutPage() {
  const navigate = useNavigate();
  const clear = useAuthStore((s) => s.clear);

  useEffect(() => {
    clear();
    setTimeout(() => navigate('/login', { replace: true }), 1000);
  }, [clear, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center">
      <p className="text-gray-500">ログアウトしました。リダイレクトしています...</p>
    </div>
  );
}
